import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getAgent} from '../../../../../selectors'

import AgentStatus from './AgentStatus'
import type {OwnProps, StateProps} from './AgentStatus.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {
    pool,
    uptodate,
    enabled = false,
    enabledInfo,
    build,
    authorized = false,
    authorizedInfo,
  } = getAgent(state, props.agentId) || {}
  const {statusSwitchTime} = enabledInfo || {}
  return {
    authorizedComment: authorizedInfo?.comment?.text,
    statusSwitchTime,
    poolId: pool?.id,
    poolName: pool?.name,
    uptodate,
    hasBuild: !!build,
    isAuthorized: authorized,
    isEnabled: enabled,
  }
}

export default connect(mapStateToProps)(AgentStatus)
